import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { SiteContentProvider } from "./context/SiteContentContext";
import { Navbar } from "./components/Navbar";
import Home from "./pages/Home";
import UpcomingLots from "./pages/UpcomingLots";
import PreviousResults from "./pages/PreviousResults";
import Consign from "./pages/Consign";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Auth from "./pages/Auth";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Provenance from "./pages/Provenance";
import { Toaster } from "sonner";

function App() {
  return (
    <AuthProvider>
      <SiteContentProvider>
        <div className="App min-h-screen bg-luxury-black font-sans-luxury text-white selection:bg-luxury-gold selection:text-black">
          <BrowserRouter>
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/upcoming" element={<UpcomingLots />} />
              <Route path="/past" element={<PreviousResults />} />
              <Route path="/consign" element={<Consign />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/provenance" element={<Provenance />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster
              theme="dark"
              position="bottom-right"
              toastOptions={{
                style: {
                  background: '#0A0A0A',
                  border: '1px solid rgba(212, 175, 55, 0.2)',
                  color: '#F5F5F5',
                  borderRadius: '0px',
                  fontFamily: 'Karla, sans-serif'
                }
              }}
            />
          </BrowserRouter>
        </div>
      </SiteContentProvider>
    </AuthProvider>
  );
}

export default App;
